module.exports = __webpack_public_path__ + "static/media/gong_logo.c43d95af.png";